import { z } from "zod";

const dateFromTimestamp = z.union([z.date(), z.number(), z.string()]).transform((val) => {
  if (val instanceof Date) {
    return val;
  }

  return new Date(val);
});

export const HomeworkSchema = z.object({
  id: z.string(),
  // Visible in the UI when a row is malformed, so a student can report exactly what they see.
  title: z.string().catch("⚠️ invalid title"),
  batchId: z.string(),
  studentId: z.string(),
  slideIds: z.array(z.string()),
  teacherId: z.string(),
  dueAt: dateFromTimestamp,
});

export type Homework = z.infer<typeof HomeworkSchema>;
